import type { ChatMessageModel } from '../client/SmartAssistantBackendClient';
export const handleFinalEvent = (params: {
  chatKey: string;
  parsedPayload: any;
  eventName?: string;
  sequencedMessagesRef: React.MutableRefObject<Map<string, { nextSeq: number; buffer: Map<number, string>; lastSeq: number }>>;
  sequencedFlushTimersRef: React.MutableRefObject<Map<string, number>>;
  flushSequencedBuffer: (targetChatId: string, state: { nextSeq: number; buffer: Map<number, string>; lastSeq: number }) => void;
  getChatBuffer: (id: string, fallback: ChatMessageModel[]) => ChatMessageModel[];
  mergeMessages: (current: ChatMessageModel[], payload: any, eventName?: string) => ChatMessageModel[];
  setChatBuffer: (id: string, messages: ChatMessageModel[]) => void;
  activeChatIdRef: React.MutableRefObject<string | null>;
  setHistory: React.Dispatch<React.SetStateAction<ChatMessageModel[]>>;
}) => {
  const eventNameLower = params.eventName?.toLowerCase();
  const isFinalEvent = params.parsedPayload?.isFinal === true
    || params.parsedPayload?.type === 'final'
    || (eventNameLower?.includes('assistantresponse') && params.parsedPayload?.type !== 'partial');
  if (!isFinalEvent) return false;

  const targetChatId = typeof params.parsedPayload?.chatId === 'string'
    ? params.parsedPayload.chatId
    : params.chatKey;
  const state = params.sequencedMessagesRef.current.get(targetChatId);
  if (state) {
    if (state.buffer.size > 0) {
      params.flushSequencedBuffer(targetChatId, state);
    }
    state.nextSeq = Number.MAX_SAFE_INTEGER;
    state.buffer.clear();
  }
  const timerId = params.sequencedFlushTimersRef.current.get(targetChatId);
  if (timerId) {
    clearTimeout(timerId);
    params.sequencedFlushTimersRef.current.delete(targetChatId);
  }

  const baseMessages = params.getChatBuffer(targetChatId, []);
  const merged = params.mergeMessages(baseMessages, params.parsedPayload, params.eventName);
  params.setChatBuffer(targetChatId, [...merged]);
  if (params.activeChatIdRef.current === targetChatId) {
    params.setHistory(merged);
  }
  return true;
};
